'use client';

import { Oura } from '@jouzen/ecom-components/icons/Oura';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import AddOnBundleProvider from '../_contexts/AddOnBundleProvider';
import AddOnModal from './_components/AddOnModal';
import ReachedThreeRingLimit from './_components/ReachedThreeRingLimit';
import StepSection from './_components/StepSection';

const Content = () => {
  const t = useTranslations();
  return (
    <AddOnBundleProvider>
      <LayoutGrid className="py-6 lg:py-14">
        <div className="col-start-2 col-end-10 flex flex-col">
          <Motion
            initial={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ amount: 1, once: true }}
            whileInView={{ opacity: 1 }}
          >
            <div className="grid grid-cols-1 grid-rows-1">
              <Image
                className="w-full rounded-lg [grid-area:1/1]"
                localizedAlt="sizing_kit"
                height={350}
                priority
                src="meta/meta_hero_img.jpg"
                width={950}
              />
              <Oura
                className="mt-5 ml-5 text-sandstone-200 [grid-area:1/1]"
                width={60}
              />
            </div>
          </Motion>
          <div className="mt-6">
            <Motion
              initial={{ opacity: 0 }}
              transition={{ delay: 0.25, duration: 0.5 }}
              viewport={{ amount: 1, once: true }}
              whileInView={{ opacity: 1 }}
            >
              <Typography
                Element="h1"
                className="pb-2 text-xl"
                data-cy="meta_checkout_title"
              >
                {t('meta_checkout_title')}
              </Typography>
              <Typography Element="h2" className="pb-10 text-base opacity-80">
                {t('meta_checkout_subcopy')}
              </Typography>
            </Motion>
            <StepSection />
          </div>
          <ReachedThreeRingLimit />
          <div
            className="flex flex-row self-end pt-10 pb-24"
            data-cy="add_on_modal"
          >
            <AddOnModal />
          </div>
        </div>
      </LayoutGrid>
    </AddOnBundleProvider>
  );
};

export default Content;
